import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, shareReplay } from 'rxjs';
import { environment } from '../../environments/environment';

export interface User {
  name: string;
  email: string;
  roles: string[];
}

@Injectable({ providedIn: 'root' })
export class UserService {
  private user$?: Observable<User>;

  constructor(private http: HttpClient) {}

  getCurrentUser(): Observable<User> {
    if (!this.user$) {
      this.user$ = this.http
        .get<User>(`${environment.apiBaseV1}user/me`)
        .pipe(shareReplay(1));
    }

    return this.user$;
  }

  clearCache(): void {
    this.user$ = undefined;
  }
}